/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { PicklistFragmentDoc } from '../../../../../features/DataChangeRequest/_graphql/fragment/Picklist.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRelationshipTypeOptionsQueryVariables = Types.Exact<{
	[key: string]: never;
}>;

export type GetRelationshipTypeOptionsQuery = {
	__typename?: 'Query';
	RELATIONSHIP_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
};

export const GetRelationshipTypeOptionsDocument = gql`
	query GetRelationshipTypeOptions {
		RELATIONSHIP_TYPE: reference(
			payload: { referenceType: RELATIONSHIP_TYPE }
		) {
			...Picklist
		}
	}
	${PicklistFragmentDoc}
`;

/**
 * __useGetRelationshipTypeOptionsQuery__
 *
 * To run a query within a React component, call `useGetRelationshipTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelationshipTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelationshipTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRelationshipTypeOptionsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetRelationshipTypeOptionsQuery,
		GetRelationshipTypeOptionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetRelationshipTypeOptionsQuery,
		GetRelationshipTypeOptionsQueryVariables
	>(GetRelationshipTypeOptionsDocument, options);
}
export function useGetRelationshipTypeOptionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetRelationshipTypeOptionsQuery,
		GetRelationshipTypeOptionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetRelationshipTypeOptionsQuery,
		GetRelationshipTypeOptionsQueryVariables
	>(GetRelationshipTypeOptionsDocument, options);
}
export function useGetRelationshipTypeOptionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetRelationshipTypeOptionsQuery,
				GetRelationshipTypeOptionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetRelationshipTypeOptionsQuery,
		GetRelationshipTypeOptionsQueryVariables
	>(GetRelationshipTypeOptionsDocument, options);
}
export type GetRelationshipTypeOptionsQueryHookResult = ReturnType<
	typeof useGetRelationshipTypeOptionsQuery
>;
export type GetRelationshipTypeOptionsLazyQueryHookResult = ReturnType<
	typeof useGetRelationshipTypeOptionsLazyQuery
>;
export type GetRelationshipTypeOptionsSuspenseQueryHookResult = ReturnType<
	typeof useGetRelationshipTypeOptionsSuspenseQuery
>;
export type GetRelationshipTypeOptionsQueryResult = Apollo.QueryResult<
	GetRelationshipTypeOptionsQuery,
	GetRelationshipTypeOptionsQueryVariables
>;
